import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  ICandidateCVs,
  getAllOtherDocs,
  getTopCV,
  getRtrPdfs,
  getCandidateDocuments,
  getJobById,
} from 'wisestep-api';

import { OtherDocuments } from '../../utils/helper';
import CandidateResume from '../childComponets/CandidateResume';
import Resizable from '../childComponets/resizable/Resizable';

import LeftPane from './components/leftPane';
import NoPreview from './components/NoPreview';
import NoPreviewDownload from './components/NoPreviewDownload';

const Documents = () => {
  const [params] = useSearchParams();
  const [cvs, setCvs] = useState<ICandidateCVs[]>([]);
  const [documents, setDocuments] = useState<OtherDocuments[]>([]);
  const [selectedFileUrl, setSelectedFileUrl] = useState<string>('');
  const [selctedCvName, setSelectedCVName] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFileType, setSelectedFileType] = useState<string>('application/pdf');

  useEffect(() => {
    async function fetchData() {
      if (!isEmpty(params.get('id'))) {
        try {
          setLoading(true);
          const response = await getTopCV(params.get('id') ?? '');
          if (response.data.length > 0) {
            setSelectedFileUrl(response?.data[0]?.documentLocation);
            setSelectedCVName(response?.data[0]?.documentFileName);
            // setSelectedFileUrl(
            //   response.data[0].isMappedCandidateResumes
            //     ? response.data[0].candidateResume[0].resumeLocation
            //     : response.data[0].resumeLocation
            // );
            // setSelectedCVName(
            //   response.data[0].isMappedCandidateResumes
            //     ? response.data[0].candidateResume[0].resumeFileOriginalName
            //     : response.data[0].resumeFileOriginalName
            // );
          }
          setCvs(response.data);

          const processDocumentsWithJobDetails = async (documents) => {
            return Promise.all(
              documents.map(async (doc) => {
                const jobDetails = await getJobById(doc.jobId ?? '');
                return {
                  ...doc,
                  jobTitle: jobDetails?.data?.title ?? '',
                  jobCode: jobDetails?.data?.jobCode ?? '',
                };
              })
            );
          };

          try {
            const documentResp = await getAllOtherDocs(params.get('id') ?? '');
            const rtrResponse = await getRtrPdfs(params.get('id') ?? '');
            const candidateDocuments = await getCandidateDocuments(params.get('id') ?? '');

            const allOtherDocuments = documentResp?.data
              ? await processDocumentsWithJobDetails(documentResp.data)
              : [];
            const allRtrDocuments = rtrResponse?.data
              ? await processDocumentsWithJobDetails(rtrResponse.data)
              : [];
            const allCandidateDocuments = candidateDocuments?.data ? candidateDocuments.data : [];

            setDocuments([...allOtherDocuments, ...allRtrDocuments, ...allCandidateDocuments]);
            console.log([...allOtherDocuments, ...allRtrDocuments, ...allCandidateDocuments]);
          } catch (error) {
            console.error('Error processing documents:', error);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.error('Error fetching data:', error);
        }
      }
    }

    fetchData();
  }, [params]);

  const getRightPanelContent = () => {
    if (selectedFileType === 'application/pdf') {
      if (cvs.length === 0) {
        return <NoPreview text={'CV/Document upload'} />;
      }
      return (
        <CandidateResume
          job={null}
          pdfResumeUrl={selectedFileUrl}
          resumeLocation={
            selectedFileUrl ??
            cvs[0]?.documentLocation ??
            documents?.[0].documentLocation ??
            documents?.[0].resumeLocation
          }
          resumeFileName={
            selctedCvName ??
            (cvs.length > 0 && cvs[0]?.documentFileName) ??
            documents?.[0].resumeFileName ??
            documents?.[0].originalName
          }
        />
      );
    } else {
      return <NoPreviewDownload selectedFileUrl={selectedFileUrl} selctedCvName={selctedCvName} />;
    }
  };

  return (
    <Resizable
      rightPanel={getRightPanelContent()}
      leftPanel={
        <LeftPane
          cvs={cvs}
          onSelect={(cv: string, fileType: string) => {
            setSelectedFileUrl(cv);
            setSelectedFileType(fileType ?? 'application/pdf');
          }}
          onSelectedCVName={(resumeFileOriginalName) => setSelectedCVName(resumeFileOriginalName)}
          documents={documents}
        />
      }
      defaultSizes={[25, 75]}
      minSize="20%"
      maxSize="80%"
      isLoading={loading}
      isDocument={true}
    />
  );
};
export default Documents;
